import React, { Component } from "react";
import logo from "./q-logo-white.png";
import { Link } from "react-router-dom";
class PanelSidebar extends Component {
  state = {};
  render() {
    return (
      <>
        <nav id="sidebar" aria-label="Main Navigation">
          <div class="side-header qlogo">
            <a class="" href="/corporate/dashboard">
              <img src={logo} class="ml-3" alt="" />
            </a>
          </div>

          <div class="content-side content-side-full">
            <ul class="nav-main">
              <li class="nav-main-item">
                <a
                  class="nav-main-link active py-3"
                  href="/corporate/dashboard"
                >
                  <i
                    class="nav-main-link-icon si si-speedometer"
                    style={{ color: "#C92127" }}
                  ></i>
                  <span class="nav-main-link-name">Dashboard</span>
                </a>
              </li>
              <li class="nav-main-item">
                <a
                  class="nav-main-link active py-3"
                  href="/corporate/employees"
                >
                  <i
                    class="nav-main-link-icon fas fa-user"
                    style={{ color: "#C92127" }}
                  ></i>
                  <span class="nav-main-link-name">Employees</span>
                </a>
              </li>
              <li class="nav-main-item">
                <a class="nav-main-link active py-3" href="/corporate/qrcodes">
                  <i
                    class="nav-main-link-icon fas fa-qrcode"
                    style={{ color: "#C92127" }}
                  ></i>

                  <span class="nav-main-link-name">Qr Codes</span>
                </a>
              </li>
              <li class="nav-main-item">
                <a class="nav-main-link active py-3" href="/corporate/tables">
                  <i
                    class="nav-main-link-icon fas fa-chair"
                    style={{ color: "#C92127" }}
                  ></i>
                  <span class="nav-main-link-name">Tables</span>
                </a>
              </li>
              <li class="nav-main-item">
                <a class="nav-main-link active py-3" href="/corporate/menu">
                  <i
                    class="nav-main-link-icon fas fa-utensils"
                    style={{ color: "#C92127" }}
                  ></i>

                  <span class="nav-main-link-name">Menu</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </>
    );
  }
}

export default PanelSidebar;
